import Axios from '@/axios';

// 批量添加授权
export const addAuthorizationBatch = data => {  
  return Axios({
    url: '/face/web/auth/batch_create_auth',
    method: 'POST',
    type: 'json',
    data
  })
}
// 查询某人有授权的设备列表
export const getPersonalAuthedDevices = params => {  
  return Axios({
    url: '/face/web/auth/index_auth_devices/' + params.id,
    method: 'GET',
    type: 'json',
    params
  })
}
// 分页查询某人没有授权的设备列表
export const getPersonalUnauthedDevices = params => {  
  return Axios({
    url: '/face/web/auth/index_not_auth_devices/' + params.id,
    method: 'GET',
    type: 'json',
    params
  })
}
// 变更某用户的授权
export const modifyPersonalAuthorization = data => {  
  return Axios({
    url: '/face/web/auth/update_auth/' + data.id,
    method: 'POST',
    type: 'json',
    data
  })
}
// 更新人员授权有效期
export const updateAuthorizedPeriod = data => {  
  return Axios({
    url: '/face/web/auth/update_auth_time',
    method: 'POST',
    type: 'json',
    data
  })
}